/*
 * @Author: 晾衣架 1308251352@qq.com
 * @Date: 2023-07-27 10:02:48
 * @LastEditors: 晾衣架 1308251352@qq.com
 * @LastEditTime: 2023-07-31 00:49:19
 * @FilePath: /m-terminal-PC/src/enums/pageEnum.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export enum PcPageEnum {
  /**
   * 游客首页
   */
  HOME = '/home',
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard',
  // 系统维护页面
  SYS_UPDATE = '/sys_update',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
}
